import {Component} from '@angular/core';
import {LoaderService} from "../../../services/loader/loader.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-loader',
  imports: [
    NgIf
  ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {

  constructor(
    private loader: LoaderService
  ) {
  }

  isLoading(): boolean {
    return this.loader.isLoading();
  }
}
